import {
  Alert,
  AlertDescription,
  AlertTitle,
} from 'designSystem/components/Alert'
import { Button } from 'designSystem/components/Button'
import { useGeckoPermissions } from 'features/permissions/hooks/useGeckoPerms'
import { Eye, Undo2 } from 'lucide-react'
import React, { type FC } from 'react'
import styled from 'styled-components'

const BannerContainer = styled.div`
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: ${({ theme }) => theme.forecast.background1};
  border-bottom: 1px solid ${({ theme }) => theme.forecast.border};
  flex-shrink: 0;
`

const BannerInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

export const AccessPreviewBanner: FC = () => {
  const { accessPreview, user, clearAccessPreview } = useGeckoPermissions()

  if (!accessPreview) return null

  const myEmail = user?.email || 'your account'

  return (
    <BannerContainer data-component='access-preview-banner'>
      <Alert variant='warning' size='sm'>
        <Eye />
        <BannerInner>
          <TextBlock>
            <AlertTitle>Viewing as {accessPreview.targetName}</AlertTitle>
            <AlertDescription>
              Nav and page controls follow their permissions. Site lists and
              data still use your access. Saving is turned off. You are still
              signed in as {myEmail}.
            </AlertDescription>
          </TextBlock>
          <Button
            variant='primaryRaised'
            size='sm'
            onClick={clearAccessPreview}>
            <Undo2 data-icon='inline-start' />
            Restore my access
          </Button>
        </BannerInner>
      </Alert>
    </BannerContainer>
  )
}
